module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-payment-option"
  }, [_c('div', {
    staticClass: "campaign-payment-option__identity"
  }, [_c('span', {
    staticClass: "campaign-payment-option__name"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), (_vm.item.ioNumber) ? _c('span', {
    staticClass: "campaign-payment-option__io"
  }, [_vm._v(_vm._s(_vm.item.ioNumber))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "campaign-payment-option__statuses"
  }, [(_vm.item.statusLoading) ? _c('v-chip', {
    attrs: {
      "color": "grey",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_vm._v("Checking status…")])]) : (_vm.item.statusUnavailable) ? _c('v-chip', {
    attrs: {
      "color": "grey darken-1",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_vm._v("Status unavailable")])]) : [(_vm.item.payoutStatus !== _vm.payoutStatus.CONFIRMED) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Pending Payout Confirmation")], 1)]) : _c('v-chip', {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("done")]), _vm._v(" Payouts Confirmed")], 1)]), _vm._v(" "), (!_vm.item.inReport) ? _c('v-chip', {
    attrs: {
      "color": "error",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("warning")]), _vm._v(" Pending in Report")], 1)]) : _c('v-chip', {
    attrs: {
      "color": "green",
      "small": ""
    }
  }, [_c('span', {
    staticClass: "campaign-payment-option__chip-text"
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("done")]), _vm._v(" Present in Report")], 1)])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44fc84e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/CampaignListPaymentStatus.vue
// module id = 2101
// module chunks = 0